export { CollectionPageLayout } from './CollectionPageLayout';
